<template>
    <div>
        <page-header
            :title="$t('pages.locker.my_coach.consulting.title')"
            :use-title-as-document-title="false"
        ></page-header>
        <div class="row">
            <div class="col-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <form class="forms-sample" @submit.prevent="contactCoach">
                            <div class="form-group">
                                <label for="title" class="font-weight-bolder">{{
                                    $t("pages.locker.my_coach.consulting.form.title")
                                }}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="title"
                                    :placeholder="
                                        $t(
                                            'pages.locker.my_coach.consulting.form.title'
                                        )
                                    "
                                    v-model="contactForm.title"
                                    :class="{
                                        'is-invalid': $errors.has('title')
                                    }"
                                />
                                <error input="title" />
                            </div>
                            <div class="form-group">
                                <label for="message" class="font-weight-bolder">{{
                                    $t("pages.locker.my_coach.consulting.form.message")
                                }}</label>
                                <textarea
                                    type="textarea"
                                    class="form-control"
                                    rows="8"
                                    id="message"
                                    :placeholder="
                                        $t(
                                            'pages.locker.my_coach.consulting.form.message'
                                        )
                                    "
                                    v-model="contactForm.message"
                                    :class="{
                                        'is-invalid': $errors.has('message')
                                    }"
                                />
                                <error input="message" />
                            </div>

                            <button class="btn btn-outline-dark">
                                {{ $t("pages.locker.my_coach.consulting.form.send") }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import LockerRoomRepository from "../../../repositories/LockerRoom/LockerRoomRepository";

export default {
    name: "Contact",
    components: { PageHeader },
    data: () => ({
        contactForm: {
            title: "",
            message: ""
        }
    }),
    methods: {
        contactCoach() {
            LockerRoomRepository.sendContactForm(this.contactForm).then(res => {
                this.$router.push({ name: "locker.my-coach" });
            });
        }
    }
};
</script>

<style></style>
